'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _extends = _assign2.default || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = require('../actionTypes');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  isFirstAuthentication: true,
  isAuthenticated: false,
  isAuthenticating: false
};

var sessionReducer = function sessionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _actionTypes2.default.AUTHENTICATE_FAILURE:
    case _actionTypes2.default.LOGOUT:
      return _extends({}, initialState);
    case _actionTypes2.default.AUTHENTICATED:
      return {
        isFirstAuthentication: false,
        isAuthenticated: true,
        isAuthenticating: false
      };
    case _actionTypes2.default.AUTHENTICATING:
      return {
        isFirstAuthentication: false,
        isAuthenticated: false,
        isAuthenticating: true
      };
    default:
      return state;
  }
};

exports.default = sessionReducer;